__turbopack_context__.v({
  "flex": "D6A2ZG_flex",
  "iconContainer": "D6A2ZG_iconContainer",
});
